import React from 'react'
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap'

const UnsavedChangesWarningModal = ({isOpen, onConfirm, onCancel}) => {
    return (
        <Modal isOpen={isOpen} toggle={onCancel} centered className="UnsavedChangesWarningModal">
            <ModalHeader toggle={onCancel} className="UnsavedChangesWarningModal__header">
                <span className="UnsavedChangesWarningModal__title">Warning!</span>
            </ModalHeader>
            <ModalBody className="UnsavedChangesWarningModal__body">
                <p className="UnsavedChangesWarningModal__message">
                    Unsaved changes will be lost.<br />
                    Please download your image before exiting.
                </p>
            </ModalBody>
            <ModalFooter className="UnsavedChangesWarningModal__footer">
                <Button 
                    outline 
                    onClick={onCancel}
                    className="UnsavedChangesWarningModal__button-cancel"
                >
                    Cancel
                </Button>
                <Button 
                    color="primary" 
                    onClick={onConfirm}
                    className="UnsavedChangesWarningModal__button-confirm"
                >
                    Confirm
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default UnsavedChangesWarningModal

